var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetMfaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.469,
    height: 14.115,
    viewBox: "0 0 17.469 14.115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48115",
    "data-name": "Group 48115",
    transform: "translate(-548.759 -354.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35938",
    "data-name": "Path 35938",
    d: "M1,4V8.186H5.186m11.163,6.977V10.977H12.163",
    transform: "translate(548.819 351.941)",
    fill: "none",
    stroke: "#385576",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35939",
    "data-name": "Path 35939",
    d: "M14.6,7.187A6.279,6.279,0,0,0,4.237,4.842L1,7.884m15.349,2.791-3.237,3.042a6.279,6.279,0,0,1-10.36-2.344",
    transform: "translate(548.819 352.242)",
    fill: "none",
    stroke: "#385576",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetMfaIcon);
export default __webpack_public_path__ + "static/media/reset_mfa_icon.8e3f2986.svg";
export { ForwardRef as ReactComponent };